
<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      :z-index="10"
      @click-left="goableBack()"
      left-arrow
      title="资讯详情"></van-nav-bar>
    <iframe
      class="content"
      :src="itemUrl"
      marginheight="0"
      marginwidth="0"
      frameborder="0"
      scrolling="yes"
      width="765"
      height="100%"
      id="iframepage"
      name="iframepage" />
  </div>
</template>

<script>
import { NavBar } from "vant"

export default {
  components: {
    [NavBar.name]: NavBar
  },
  beforeMount() {
    this.itemUrl = this.$route.query.itemUrl
    console.log(this.itemUrl)
  },
  mounted() {
    /**
     * iframe-宽高自适应显示
     */
    function changeMobsfIframe() {
      const mobsf = document.getElementById("iframepage")
      const deviceWidth = document.body.clientWidth
      const deviceHeight = document.body.clientHeight
      mobsf.style.width = Number(deviceWidth) + "px" //数字是页面布局宽度差值
      //   mobsf.style.height = Number(deviceHeight) + 'px'; //数字是页面布局高度差
    }

    changeMobsfIframe()

    window.onresize = function () {
      changeMobsfIframe()
    }
  },
  data() {
    return {
      itemUrl: "",
      item: {}
    }
  },
  methods: {
    iFrameHeight() {
      var ifm = document.getElementById("iframepage")
      var subWeb = document.frames
        ? document.frames["iframepage"].document
        : ifm.contentDocument
      if (ifm != null && subWeb != null) {
        ifm.height = subWeb.body.scrollHeight
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  width: 100%;
}
iframe {
  transform-origin: 0 top 0;
  img {
    width: 100%;
  }
}
.content {
  width: 100%;
  height: 1000px;
}
</style>